<main [class]="classes()">
    <ng-content />
</main>
